module.exports = __webpack_public_path__ + "img/angle-right-solid.eef567e9.svg";